import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { getTypeFromAlias } from '../../../utils/Utils';

export interface EntityTypeGuardProps {
  types: string[];
  children: ReactNode;
  currentSubType?: string;
  subTypes?: string[];
  pathname?: string;
}

function EntityTypeGuard(props: EntityTypeGuardProps) {
  const { types, children, subTypes = [''], currentSubType = '' } = props;
  const { entityType = '' } = useParams();
  const currentEntityType = getTypeFromAlias(entityType);
  return <>{types.includes(currentEntityType) && subTypes.includes(currentSubType) && children}</>;
}

export default EntityTypeGuard;
